import React from 'react';
import { Hero } from '../components/Hero';
import { Lead } from '../components/Lead';
import { PainPoints } from '../components/PainPoints';
import { OldSolutions } from '../components/OldSolutions';
import { Mechanism } from '../components/Mechanism';
import { FAQ } from '../components/FAQ';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
import { MetaPixel } from '../components/MetaPixel';
export function LandingPage() {
  return <main className="min-h-screen bg-[#0a0a0f] text-[#f5f5f5] selection:bg-[#ff2d7a] selection:text-white overflow-x-hidden" data-id="element-133">
      {/* Meta Pixel */}
      <MetaPixel data-id="element-134" />

      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-135">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=780668617738771&ev=PageView&noscript=1" alt="" data-id="element-136" />
      </noscript>

      <Hero data-id="element-137" />
      <Lead data-id="element-138" />
      <PainPoints data-id="element-139" />
      <OldSolutions data-id="element-140" />
      <Mechanism data-id="element-141" />
      <FAQ data-id="element-142" />
      <FinalCTA data-id="element-143" />
      <Footer data-id="element-144" />
    </main>;
}